import { COMPARISON_ROWS } from "../data/comparisonTable";

/** Desktop table / mobile stacked cards — a cramped table never ships to small viewports. */
export default function ComparisonTable() {
  return (
    <div>
      <div className="hidden overflow-x-auto rounded-2xl ring-1 ring-ocean-900/5 sm:block">
        <table className="w-full text-left text-sm">
          <thead className="bg-foam-100 text-xs uppercase tracking-wide text-ocean-800/60">
            <tr>
              <th className="px-4 py-3">Dimension</th>
              <th className="px-4 py-3 text-teal-700">ZenFresh</th>
              <th className="px-4 py-3">Traditional Market</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-ocean-900/5 bg-white">
            {COMPARISON_ROWS.map((row) => (
              <tr key={row.dimension}>
                <td className="px-4 py-3 font-medium text-ocean-950">{row.dimension}</td>
                <td className="px-4 py-3 text-teal-700">{row.zenfresh}</td>
                <td className="px-4 py-3 text-ocean-800/60">{row.traditionalMarket}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="space-y-4 sm:hidden">
        {COMPARISON_ROWS.map((row) => (
          <div key={row.dimension} className="rounded-2xl bg-white p-5 shadow-sm ring-1 ring-ocean-900/5">
            <h4 className="font-display text-sm font-semibold text-ocean-950">{row.dimension}</h4>
            <div className="mt-3 space-y-2">
              <div className="rounded-lg bg-teal-400/10 p-3">
                <span className="text-[10px] font-semibold uppercase tracking-wide text-teal-700">ZenFresh</span>
                <p className="mt-1 text-sm text-ocean-800/80">{row.zenfresh}</p>
              </div>
              <div className="rounded-lg bg-ocean-900/5 p-3">
                <span className="text-[10px] font-semibold uppercase tracking-wide text-ocean-800/50">
                  Traditional Market
                </span>
                <p className="mt-1 text-sm text-ocean-800/70">{row.traditionalMarket}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
